import { connect } from 'react-redux';

import PricewatchSubscribeForm from '@lt/components/components/PricewatchSubscribeForm';

import { getClientEmail } from 'src/store/client/selectors';
import {
  paramsForSubscribtionSelector,
  viewParamsForSubscribtionSelector,
} from '../../domain/state/priceSubcription/selectors';
import { getIsMobile } from '../../../../store/view/selectors';

import { toggleSubscribeAction } from '../../domain/state/view/actions';
import { setIsSubscribedOnPrice } from '../../domain/state/priceSubcription/slice';

import { dataLayerPush, dataLayerPushParams } from '../../../../helpers/gtm';
import { api } from '../../../../api';

const mapStateToProps = (state) => ({
  email: getClientEmail(state),
  subscriptionParams: paramsForSubscribtionSelector(state),
  viewParams: viewParamsForSubscribtionSelector(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (params) => api.postPriceAlertsSubscriptionsCreate(params),
  setIsSubscribedOnPrice: () => dispatch(setIsSubscribedOnPrice()),
  onCancel: () => dispatch(toggleSubscribeAction()),
  dataLayerPush,
  dataLayerPushParams,
});

const mergeProps = (stateProps, { onCancel, ...dispatchProps }) => ({
  ...stateProps,
  ...dispatchProps,
  onCancel: stateProps.isMobile ? onCancel : null,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(PricewatchSubscribeForm);
